import { useT } from '../../i18n/useT'

/** Landing block that turns the no-storage policy into a selling point. */

const ICONS = [
  <path
    key="shield"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
  />,
  <path
    key="clock"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
  />,
  <path
    key="device"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 002.25-2.25v-15a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 4.5v15a2.25 2.25 0 002.25 2.25z"
  />,
]

export function PrivacySection() {
  const t = useT()
  const points = [
    { title: t('privacy.p1.title'), text: t('privacy.p1.text'), icon: ICONS[0] },
    { title: t('privacy.p2.title'), text: t('privacy.p2.text'), icon: ICONS[1] },
    { title: t('privacy.p3.title'), text: t('privacy.p3.text'), icon: ICONS[2] },
  ]
  return (
    <section className="py-16 bg-surface-alt">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-text">{t('privacy.title')}</h2>
          <p className="mt-3 text-text-secondary">{t('privacy.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {points.map((point, i) => (
            <div key={i} className="bg-surface border border-border rounded-2xl p-6">
              <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                  {point.icon}
                </svg>
              </div>
              <h3 className="mt-4 text-base font-semibold text-text">{point.title}</h3>
              <p className="mt-1.5 text-sm text-text-secondary leading-relaxed">{point.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
